import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as DefaultLogo } from "../../assets/images/diya_logo.svg"; // SVG as React component
import { useGlobalContext } from "../../context/GlobalContext";
import { logOutHandler } from "../../utils/authHelpers";
import profileImageHolder from "../../assets/images/Avatar.png";
import Button from "../Buttons";
import { CONSTANTS } from "../../constants/Constants";
import { feedbackFormHandler } from "../../utils/helpers";
import ProfileDropdown from "../AuthDropDown";
import { useNavigate } from "react-router-dom";
import Logo from "./Logo";

const Header: React.FC = () => {
  const { user, setUser, showHeader, setIsModifyDashboardModalOpen, currentProfile, isLoading } = useGlobalContext();
  const [isOpen, setIsOpen] = useState(false);
  const [companyLogo, setCompanyLogo] = useState<string>("")
  const navigate = useNavigate()
  const dropdownRef = useRef<HTMLDivElement>(null);
  const logOutUser = () => {
    logOutHandler();
    setUser({});
    setIsOpen(false)
  };

  useEffect(() => {
    setCompanyLogo(user?.user?.companyLogo || currentProfile?.companyLogo)
  }, [user, currentProfile])

  const showDefaultLogo = (!isLoading && window.location.pathname.split("/")[1] === "profile-detail") ||
    window.location.pathname.split("/")[1] === "login";

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {!showHeader ? (
        <></>
      ) : (
        <div className="relative flex items-center justify-between h-[90px] bg-gray-100 layout-container">
          <div className={`${user.token ? "cursor-pointer" : ""
            } overflow-hidden w-[160px]`} onClick={user?.token ? () => navigate("/dashboard") : () => { }}>
            {companyLogo ? (
              <Logo
                src={companyLogo}
                alt="Company Logo"
                className="max-h-[75px] w-auto"
              />
            ) : (
              showDefaultLogo && (
                <DefaultLogo
                  className="object-contain w-[110px] lg:w-[150px]"
                />
              )
            )}
          </div>

          <div className="flex items-center gap-2">
            {window.location.pathname === "/dashboard" && (
              <div className="hidden md:flex gap-2">
                <>
                  <Button
                    btn_label={CONSTANTS.CUSTOMIZE_YOUR_DASHBOARD}
                    on_click_handler={() => setIsModifyDashboardModalOpen(true)} // hasn't used
                    other_classes={
                      "w-fit !h-10 px-5 !bg-[#F8F8F8] !text-black text-[12px] border border-[#BABABA]"
                    }
                  />

                  <Button
                    btn_label={CONSTANTS.FEEDBACK_TXT}
                    on_click_handler={feedbackFormHandler}
                    other_classes={
                      "!w-fit !h-10 px-5 !bg-[#F8F8F8] !text-black text-[12px] border border-[#BABABA]"
                    }
                  />
                  {user?.permissions?.GetAllUsers && (
                    <Button
                      btn_label={CONSTANTS.USERS_TXT}
                      on_click_handler={() => navigate("/users")}
                      other_classes={
                        "!w-fit !h-10 px-5 !bg-[#F8F8F8] !text-black text-[12px] border border-[#BABABA]"
                      }
                    />
                  )}
                  {!user?.user?.subId && <Button
                    btn_label={CONSTANTS.UPGRADE_TXT}
                    on_click_handler={() => window.location.href = "/pricing-plan"}
                    other_classes={
                      "!w-fit !h-10 px-5 !text-white text-[12px] border border-[#BABABA]"
                    }
                  />}
                </>
              </div>
            )}

            {user.token && (
              <div
                onClick={() => setIsOpen(true)}
                className="cursor-pointer w-12 h-12 lg:w-11 lg:h-11 rounded-full overflow-hidden"
              >
                <img
                  src={user?.user?.imageUrl || profileImageHolder}
                  alt="Profile"
                  className="object-cover rounded-full border-2 h-full w-full"
                  width={64}
                  height={64}
                />
              </div>
            )}
          </div>
          {isOpen && <ProfileDropdown
            user={user}
            onLogout={logOutUser}
            dropdownRef={dropdownRef}
          />}
        </div>
      )}
    </>
  );
};

export default Header;
